<template>
  <div class="eventmap-page__control-icons">
    <a class="eventmap-page__control-icon" href="#" @click.prevent="eventmapSVG?.zoom(3/4)">
      <i class="far fa-plus"></i>
    </a>
    <a class="eventmap-page__control-icon" href="#" @click.prevent="eventmapSVG?.zoom(4/3)">
      <i class="far fa-minus"></i>
    </a>
    <a class="eventmap-page__control-icon" href="#" @click.prevent="eventmapSVG?.resetViewBox">
      <i class="far fa-expand-wide"></i>
    </a>
    <a v-if="mode !== 'kiosk'" class="eventmap-page__control-icon" href="#" @click.prevent="toggleFullScreenMode">
      <i :class="fullScreenMode ? 'far fa-arrows-minimize' : 'far fa-arrows-maximize'"></i>
    </a>
  </div>
</template>

<script setup>
defineProps({
  mode: {
    type: String,
    default: 'platform',
  },
});

const eventmapSVG = defineModel('eventmapSVG', { type: Object, default: null });
const fullScreenMode = defineModel('fullScreenMode', { type: Boolean, default: null });

const toggleFullScreenMode = () => {
  fullScreenMode.value = !fullScreenMode.value;
};
</script>
